export const createOrderTypesForm = (source = {}) => ({
  dineIn: Boolean(source?.allowDineIn),
  takeout: Boolean(source?.allowTakeaway),
  delivery: Boolean(source?.allowDelivery),
});

export const toOrderTypesPayload = (form = {}) => ({
  allowDineIn: Boolean(form?.dineIn),
  allowTakeaway: Boolean(form?.takeout),
  allowDelivery: Boolean(form?.delivery),
});

